<template>
  <v-container>
    <v-row >
      <v-col class="pa-0"  style="background:#19442B;">
        <img
          id="about-us"
          style="width:100%"
          :src="require('../assets/about_us_banner.jpg')"
          @load="onImgLoad('#about-us')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pic-desc" style="position:relative;">
        <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-l3-chi'" class="sub-title">
          {{$t('company_page.about_us_title')}}
        </div>
        <div :class="$i18n.locale=='en'?'DinCond font-size-L about-us-text-content-eng': 'MHeiHK about-us-text-content-chi'" style="width:80%; margin:auto;" v-html="$t('company_page.about_us_content')">
        </div>
        <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
      </v-col>
    </v-row>
    <!-- <v-row style="background:#132b1b;position:relative;" id="our-leadership">
      <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-l3-chi'" class="sub-title about-us-title-margin">{{$t('company_page.leadership_title')}}</div>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <v-row v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" style="justify-content: center;align-items: center;background:#132b1b;position:relative;">
      <div class="img-left">
        <img class="potrait-size"
          :src="require('../assets/man1.jpg')"
        />
        <div :class="$i18n.locale=='en'?'georgia font-size-l1':'NotoSerifTC'" class="img-title-left about-us-founder">
          {{$t('company_page.leader1_title')}}
        </div>
        <div :class="$i18n.locale=='en'?'DinCond font-size-l1':'NotoSerifTC'" class="img-name-left about-us-founder">
          {{$t('company_page.leader1_name')}}
        </div>
      </div>
      <v-divider vertical style="border-color: white;"></v-divider>
      <div class="img-right">
        <img class="potrait-size"
          :src="require('../assets/man2.jpg')"
          @load="onImgLoad('#our-leadership')"
        />
        <div :class="$i18n.locale=='en'?'georgia font-size-l1':'NotoSerifTC'" class="img-title-right about-us-founder">
          {{$t('company_page.leader2_title')}}
        </div>
        <div :class="$i18n.locale=='en'?'DinCond font-size-l1':'NotoSerifTC'" class="img-name-right about-us-founder">
          {{$t('company_page.leader2_name')}}
        </div>
      </div>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:500"></div>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" :class="{'mobile': $vuetify.breakpoint.sm}" style="justify-content: center;align-items: center;background:#132b1b;position:relative;">
      <v-col style="padding:18px;border-right: 1px white solid;">
        <img 
          style="width:100%"
          :src="require('../assets/man1.jpg')"
        />
        <div :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="text-left about-us-founder">
          {{$t('company_page.leader1_title')}}
        </div>
        <div :class="$i18n.locale=='en'?'DinCond':'NotoSerifTC'" class="text-left about-us-founder">
          {{$t('company_page.leader1_name')}}
        </div>
      </v-col>
      <v-col style="padding:18px;">
        <img
          style="width:100%"
          :src="require('../assets/man2.jpg')"
        />
        <div :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="text-left about-us-founder">
          {{$t('company_page.leader2_title')}}
        </div>
        <div :class="$i18n.locale=='en'?'DinCond':'NotoSerifTC'" class="text-left about-us-founder">
          {{$t('company_page.leader2_name')}}
        </div>
      </v-col>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:100"></div>
    </v-row> -->
    <v-row style="background:#132b1b;position:relative;" id="our-services">
      <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-l3-chi'" class="sub-title about-us-title-margin">{{$t('company_page.our_services_title')}}</div>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <v-row v-if="!$vuetify.breakpoint.xs">
      <v-col lg="6" md="6" xl="6" class="pa-0" style="position:relative;background: #19442B;">
        <div class="pa-2">
          <img
            style="width:100%"
            :src="require('../assets/Certificate_ourcompany.png')"
            @load="onImgLoad('#our-services')"
          />
          <div style="background:white;bottom:8px;left:8px;right:8px;" class="showfromtop" data-aos="showeffect2" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:900"></div>
        </div>
      </v-col>
      <v-col lg="6" md="6" xl="6" class="pic-desc d-flex align-center justify-center" style="text-align:left;position:relative;">
        <div :class="$i18n.locale=='en'?'DinCond font-size-L':'MHeiHK about-us-text-content-chi'" class="pic-desc-container about-us-text-content" style="padding:3%;" v-html="$t('company_page.about_us_content')">
        </div>
        <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:900"></div>
      </v-col>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.xs">
      <div class="pa-0" style="position:relative;background: #19442B;">
        <div class="pa-0">
          <img
            style="width:100%"
            :src="require('../assets/Certificate_ourcompany.png')"
            @load="onImgLoad('#our-services')"
          />
          <div style="background:white;bottom:8px;left:8px;right:8px;" class="showfromtop" data-aos="showeffect2" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:100"></div>
        </div>
      </div>
      <div class="pic-desc d-flex align-center justify-center" style="text-align:left;position:relative;">
        <div :class="$i18n.locale=='en'?'DinCond':'MHeiHK'" class="pic-desc-container about-us-text-content-chi text-center" style="padding:10%;" v-html="$t('company_page.about_us_content')">
        </div>
        <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:300"></div>
      </div>
    </v-row>
    <v-row style="background:#132b1b;position:relative;" id="our-logos">
      <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-l3-chi'" class="sub-title about-us-title-margin">{{$t('company_page.our_logos_title')}}</div>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <v-row class="pa-0 d-flex justify-center" style="margin-top:20px;">
      <v-col lg="10" md="10" xl="10" sm="12" style="background:#132b1b;position:relative;">
        <img
          :src="require('../assets/our_logo.png')"
          max-width="100%"
          style="width:100%"
          @load="onImgLoad('#our-logos')"
        />
        <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:400"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
 
  export default {
    name: 'Company',
    components: {
    },
    data: () => ({
      "cc": {
      },
      isLoaded: false
    }),
    mounted(){
    },
    methods: {
      onImgLoad(id) {
        if(window.location.hash == id)
          this.$scrollTo(id, 2000)
      }
    }
  }
</script>

<style scoped>
.special-text{
  color: #E1CB8B;
}
.pic-desc{
  color: white;
  background-color: #19442B;
  letter-spacing: 1px;
}
.sub-title{
  letter-spacing: 10px;
  padding: 3%;
  color: white;
  margin: auto;
}
.mobile .sub-title{
  letter-spacing: 4px;
  color: white;
  margin: auto;
  margin-top:20px;
}
.img-left{
  position: relative;
  max-width: 23%;
  margin: 3%;
  margin-top: 0px;
}
.img-right{
  position: relative;
  max-width: 23%;
  margin: 3%;
  margin-top: 80px;
}
.img-title-left{
  letter-spacing: 5px;
  position: absolute;
  top: 10%;
  left: -37%;
  color: white;
}
.img-name-left{
  position: absolute;
  top: 17%;
  left: -37%;
  color: white;
}
.img-title-right{
  white-space: nowrap;
  letter-spacing: 5px;
  position: absolute;
  top: 80%;
  left: 80%;
  color: white;
}
.img-name-right{
  white-space: nowrap;
  position: absolute;
  top: 87%;
  left: 80%;
  color: white;
}
.service-desc{
  color: white;
  background: #19442B;
}
.pic-desc-container{
  margin: auto;
}
.logo{
  width: 300px;
}

.mini-logo{
  width:200px;
  margin:2%
}
.georgia{
  font-family: Georgia, 'Times New Roman', Times, serif !important;
}
.mobile .about-us-founder{
  color: white;
  line-height: 1.2;
}

@media (min-width: 375px) {
  .about-us-text-content-chi{
    font-size: 13px;
    padding-bottom:10px;
    line-height: 1.8;
    letter-spacing: 3px;
  }
}  

@media (min-width: 768px){
  .about-us-text-content-chi{
    font-size: 13px;
    padding-bottom:10px;
    line-height: 1.8;
    letter-spacing: 3px;
  }
}

@media (min-width: 992px){
  .about-us-text-content-eng{
    padding-bottom:10px;
    letter-spacing: 1px;
  }
  
  .about-us-text-content-chi{
    font-size: 13px;
    padding-bottom:10px;
    line-height: 1.8;
    letter-spacing: 3px;
  }
}

@media (min-width: 1264px){
  .about-us-text-content-eng{
    padding-bottom:30px;
    letter-spacing: 1px;
  }

  .about-us-text-content-chi{
    font-size: 15px;
    padding-bottom:30px;
    line-height: 1.8;
    letter-spacing: 5px;
  }
}  

@media (min-width: 1904px){
  .about-us-text-content-eng{
    padding-bottom:50px;
    letter-spacing: 1px;
  }

  .about-us-text-content-chi{
    font-size: 20px;
    padding-bottom:50px;
    line-height: 1.8;
    letter-spacing: 8px;
  }
}  

@media (min-width: 992px) { 
  .pic-desc-container{
    width:88%;
  }
  .about-us-founder{
    font-size: 15px;
    padding-bottom:10px;
  }
  .about-us-title-margin{
    margin-top:50px
    
  }

  .potrait-size{
    max-width:210px;
  }
}
@media (min-width: 1264px) {
  .pic-desc-container{
    width:83%;
  }
  .about-us-founder{
    font-size: 18px;
    padding-bottom:30px;
  }
  .about-us-title-margin{
    margin-top:75px
  }

  .potrait-size{
    max-width:270px;
  }
}
@media (min-width: 1904px){
  .pic-desc-container{
    width:70%;
  }
  .about-us-founder{
    font-size: 25px;
    padding-bottom:50px;
  }
  .about-us-title-margin{
    margin-top:100px
  }

    .potrait-size{
    max-width:330px;
  }

}

</style>